/**
 * External dependencies
 */
import { useEffect, useState, useCallback } from '@wordpress/element';
import { __ } from '@wordpress/i18n';
import { useSelect, useDispatch } from '@wordpress/data';
import { debounce } from 'lodash';
import { extensionCartUpdate, Button } from '@woocommerce/blocks-checkout';
import { getSetting } from '@woocommerce/settings';
import classNames from 'classnames';

//Store payment method ID when payment method is changed
wp.hooks.addAction('experimental__woocommerce_blocks-checkout-set-active-payment-method', 'vp-woo-pont-block', function(payment_method) {

	//But only if we have COD fees enabled, otherwise not needed
	const { codFeesEnabled } = getSetting( 'vp-woo-pont-picker_data', '' );
	if(codFeesEnabled) {
		extensionCartUpdate({
			namespace: 'vp-woo-pont-picker',
			cartPropsToReceive: [ 'extensions' ],
			data: {
				payment_method: payment_method.value
			}
		});
	}

});

const Block = ( { text, selectButton, changeButton, showIcons, checkoutExtensionData, extensions, cart } ) => {
	const { setExtensionData } = checkoutExtensionData;
	// eslint-disable-next-line react-hooks/exhaustive-deps
	const debouncedSetExtensionData = useCallback(
		debounce( ( namespace, key, value ) => {
			setExtensionData( namespace, key, value );
		}, 1000 ),
		[ setExtensionData ]
	);

	//Setup shipping costs
	const [shippingCosts, setShippingCosts] = useState(() => {
		return extensions['vp-woo-pont-picker']['shipping_costs'];
	});

	//Check if we have stored info in the session
	const selectedPont = extensions['vp-woo-pont-picker'] && extensions['vp-woo-pont-picker']['selected_pont'];
	const [selectedPickupPoint, setSelectedPickupPoint] = useState(selectedPont || false);

	//Show a loading indicator
	const [isLoading, setIsLoading] = useState(false);

	//Handle pickup point selection
	useEffect(() => {
		const eventListener = () => {
			handlePointSelected();
		};

    	//Add event listener
		jQuery(document).on('vp_woo_pont_modal_point_selected', eventListener);

    	//Clean up the event listener when the component unmounts
    	return () => {
			jQuery(document).off('vp_woo_pont_modal_point_selected', eventListener);
    	};
	}, []);

	//Runs when a point is selected, show loading indicator and reload data
	const handlePointSelected = () => {
		
		//Show loading indicator
		setIsLoading(true);

		//Do a cart update, which will return the selected point data, since its stored in session(done with an ajax call in jquery map script)
		extensionCartUpdate( {
			namespace: 'vp-woo-pont-picker',
			cartPropsToReceive: [ 'extensions' ],
		} ).then( (response) => {

			//Hide loading indicator
			setIsLoading(false);

			//Set selected point data
			if(response['extensions']['vp-woo-pont-picker'] && response['extensions']['vp-woo-pont-picker']['selected_pont']) {
				setSelectedPickupPoint(response['extensions']['vp-woo-pont-picker']['selected_pont']);
			}
		});
	};

	//Check if local pickup is selected
	const { prefersCollection } = useSelect(
		( select ) => {
			const checkoutStore = select( 'wc/store/checkout' );
			return {
				prefersCollection: checkoutStore.prefersCollection(),
			};
		}
	);

	//Get an array of shipping method ids that are collectable
	const collectableMethodIds = getSetting('collectableMethodIds');

	//Loop though shipping rates and see if we only have maximum one collectable method
	const collectableShippingRates = cart.shippingRates[0].shipping_rates.filter(rate => (
		collectableMethodIds.includes(rate.method_id)
	));

	//If we have only have one collectable method, show pickup point selector
	const isPontMethodSelectedDefault = collectableShippingRates.length == 1;

	//Check if the selected shipping method is vp_pont
	const isPontMethodSelected = cart.shippingRates[0].shipping_rates.find(rate => (
		rate.selected && rate.method_id === 'vp_pont'
	));

	if (isPontMethodSelected || (prefersCollection && isPontMethodSelectedDefault)) {
		return (
				<div className={ classNames( 'vp-woo-pont-block', {'wc-block-components-loading-mask': isLoading} ) }>
					<div className="vp-woo-pont-block-box wc-block-components-loading-mask__children">
						{!selectedPickupPoint ? (
							<div className="vp-woo-pont-block-select">
								<p className='vp-woo-pont-block-select-title'>{text}</p>
								{showIcons &&
								<div className="vp-woo-pont-block-select-icons">
								{shippingCosts && Object.keys(shippingCosts).map(provider => (
									<i key={provider} className={`vp-woo-pont-provider-icon-${provider}`}></i>
								))}
								</div>
								}
							</div>
						) : (
							<div className="vp-woo-pont-block-selected">
								<i className={`vp-woo-pont-provider-icon-${selectedPickupPoint.provider}`}></i>
								<div className="vp-woo-pont-block-selected-info">
									<strong>{selectedPickupPoint.name}</strong><br/>
									<span>{selectedPickupPoint.addr}, {selectedPickupPoint.zip}{' '}{selectedPickupPoint.city}</span>
								</div>
							</div>
						)}

						<div className="vp-woo-pont-block-select-button" data-shipping-costs={JSON.stringify(shippingCosts)}>
							<Button className="vp-woo-pont-show-map">{selectedPickupPoint ? changeButton : selectButton}</Button>
						</div>
					</div>
					{ isLoading && <span className="wc-block-components-spinner" aria-hidden="true" /> }
				</div>
		);
	}
};

export default Block;